import React from 'react';
import Language from './Language';
import Localized from '../Localized';
import en from './strings/en.json';
import fr from './strings/fr.json';
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";

import $ from 'jquery';

class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = { inputValue: '' };
        this.lang = 'en';
        if (this.props.activeLanguage)
            this.lang = this.props.activeLanguage.code;
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            
            this.searchTerm();
        }
    }

    toogle() {
        $("body").toggleClass("sidebar-toggled");
        $(".sidebar").toggleClass("toggled");
        if ($(".sidebar").hasClass("toggled")) {
            $('.sidebar .collapse').collapse('hide');
        };
    }

    updateInputValue(evt) {
        this.setState({
            inputValue: evt.target.value
        });
    }

    searchTerm() {
        console.log(`searchTerm`);

        function fetchWithPage(root, lang, element) {
            return new Promise(function (resolve, reject) {
                var file = `${root}/${element.Path}.${lang}.md?v=1.045`;
                fetch(file).then(t => {
                    resolve({ 'response': t, 'page': element });
                })
            })
        }

        function getTextAndUrl(res) {
            return new Promise(function (resolve, reject) {
                res.response.text().then(t => {
                    resolve({ 'text': t, 'page': res.page });
                })
            });
        }

        var root = `${process.env.PUBLIC_URL}/markdown`;

        fetch(`${root}/config.json?v=1.045`).then((response) => response.text()).then((text) => {
            var pages = JSON.parse(text);
            var urls = [];
            pages.Pages.forEach(element => {
                urls.push(element);
            });
            Promise.all(urls.map(u => fetchWithPage(root, this.lang, u)))
                .then(responses =>
                    Promise.all(responses.map(res => getTextAndUrl(res)))
                ).then(text => {
                    var u = [];
                    text.forEach(element => {
                        var index = element.text.toLowerCase().indexOf(this.state.inputValue.toLowerCase());
                        if (index > -1)
                            u.push({ "page": element.page, "index": index });
                    });
                    this.props.showResults(u);
                })
        })

    }
    render() {
        return (
            <Localized en={en} fr={fr}>
                <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
                    <a id="sidebarToggleTop" href="#" onClick={this.toogle.bind(this)} className="btn btn-link d-md-none rounded-circle mr-3">
                        <i className="fa fa-bars"></i>
                    </a>

                    <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
                        <div className="input-group">
                            <Translate>
                                {({ translate }) =>
                                    <input type="text" onKeyPress={this.handleKeyPress.bind(this)} onChange={this.updateInputValue.bind(this)} className="form-control bg-light border-1 small"
                                        placeholder={translate('search')}
                                        aria-label="Search"
                                        aria-describedby="basic-addon2" />
                                }
                            </Translate>
                            <div className="input-group-append">
                                <button className="btn btn-primary" type="button" onClick={this.searchTerm.bind(this)}>
                                    <i className="fas fa-search fa-sm"></i>
                                </button>
                            </div>
                        </div>
                    </form>

                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item dropdown no-arrow mx-1">
                            <a className="nav-link dropdown-toggle" href="mailto:contact@datamodeler.fr">
                                <i className="fas fa-envelope fa-fw"></i><small className="ml-1">Contact</small>
                            </a>
                        </li>
                        <li className="nav-item dropdown no-arrow">
                            <a className="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {this.props.activeLanguage &&
                                    <div>
                                        <small><Translate id={this.props.activeLanguage.name} /><span>({this.props.activeLanguage.code})</span></small>
                                    </div>
                                }
                            </a>
                            <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                                {this.props.languages.map(lang => (
                                    <Language language={lang.name} code={lang.code} key={lang.code} />
                                ))}
                            </div>
                        </li>
                    </ul>
                </nav>
            </Localized>
        );
    }
}

export default withLocalize(Header);